module.exports = __webpack_public_path__ + "img/mocking.29325e7b.png";